"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// import FacebookLogo from "../../../../../assets/logos/facebook.svg";
// import GoogleLogo from "../../../../../assets/logos/google.svg";
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var gmc_logo_svg_1 = __importDefault(require("../../../../../assets/logos/gmc_logo.svg"));
var shopify_svg_1 = __importDefault(require("../../../../../assets/logos/shopify.svg"));
var routes_1 = require("../../../../../constants/routes");
var client_1 = require("../../../../../reducers/slices/client/client");
var main_1 = require("../../../../../reducers/slices/main");
var add_algolia_1 = require("./algolia/add_algolia");
var constants_1 = require("./algolia/constants");
var channel_1 = __importDefault(require("./channel"));
var add_gmc_connector_1 = __importDefault(require("./gmc/add_gmc_connector"));
var constants_2 = require("./gmc/constants");
var add_mark_up_1 = require("./uber/add_mark_up");
var add_uber_1 = require("./uber/add_uber");
var constants_3 = require("./uber/constants");
var add_inventory_file_1 = __importDefault(require("./gmc/add_inventory_file"));
var AllChannelComponent = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var channel_type = (0, react_router_dom_1.useParams)().channel_type;
    var _a = (0, react_router_dom_1.useSearchParams)(), searchParams = _a[0], setSearchParams = _a[1];
    var _integrationExists = function (type) { return clientIntegrations.find(function (int) { return int.type === type; }); };
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }), clientIntegrations = _b.clientIntegrations, client = _b.client;
    var onAddIntegration = function (type) {
        var existingIntegrationValues = clientIntegrations.find(function (int) { return int.type === type; });
        switch (type) {
            case constants_3.UBER:
                dispatch((0, client_1.setSelectedClientIntegration)(existingIntegrationValues !== null && existingIntegrationValues !== void 0 ? existingIntegrationValues : constants_3.initialUberIntValues));
                dispatch((0, main_1.setContentModal)({
                    title: "Connect with uber",
                    content: (0, jsx_runtime_1.jsx)(add_uber_1.AddUber, {}),
                }));
                break;
            case constants_2.GOOGLE_MERCHANT_CENTER:
                dispatch((0, client_1.setSelectedClientIntegration)(existingIntegrationValues !== null && existingIntegrationValues !== void 0 ? existingIntegrationValues : constants_3.initialUberIntValues));
                dispatch((0, main_1.setContentModal)({
                    title: "Connect with Google Merchant Center",
                    content: (0, jsx_runtime_1.jsx)(add_gmc_connector_1.default, {}),
                }));
                break;
            case constants_1.ALGOLIA:
                dispatch((0, client_1.setSelectedClientIntegration)(existingIntegrationValues !== null && existingIntegrationValues !== void 0 ? existingIntegrationValues : constants_1.initialAlgoliaIntValues));
                dispatch((0, main_1.setContentModal)({
                    title: "Connect with Algolia",
                    content: (0, jsx_runtime_1.jsx)(add_algolia_1.AddAlgolia, {}),
                }));
                break;
        }
    };
    var onOptionButton = function (type) {
        var existingIntegrationValues = clientIntegrations.find(function (int) { return int.type === type; });
        switch (type) {
            case constants_3.UBER:
                dispatch((0, client_1.setSelectedClientIntegration)(existingIntegrationValues !== null && existingIntegrationValues !== void 0 ? existingIntegrationValues : constants_3.initialUberIntValues));
                dispatch((0, main_1.setContentModal)({
                    title: "Apply Standard Markup to All Products.",
                    content: (0, jsx_runtime_1.jsx)(add_mark_up_1.AddMarkUp, {}),
                }));
            case constants_2.GOOGLE_MERCHANT_CENTER:
                dispatch((0, client_1.setSelectedClientIntegration)(existingIntegrationValues !== null && existingIntegrationValues !== void 0 ? existingIntegrationValues : constants_3.initialUberIntValues));
                dispatch((0, main_1.setContentModal)({
                    title: "Upload Inventory file.",
                    content: (0, jsx_runtime_1.jsx)(add_inventory_file_1.default, {}),
                }));
                break;
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-3 auto-cols-md gap-4" }, { children: [(0, jsx_runtime_1.jsx)(channel_1.default, { title: "Shopify", logo: shopify_svg_1.default, learnMoreLink: "https://www.shopify.com", label: "By connecting your account, you agree to \n              Shopify\u2019s terms and conditions.\n              You need to follow shopify\u2019s customer support and delivery & return policies when selling on Shopify.\n        ", onClick: function () {
                    navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CHANNELS_ROUTE, "/shopify"));
                } }), (0, jsx_runtime_1.jsx)(channel_1.default, { title: "Uber", learnMoreLink: "https://www.uber.com/", label: "By connecting your account, you agree to \n      Google's terms and conditions.\n      You need to follow Uber's customer support and delivery & return policies when selling on Google.\n      ", optionalButton: _integrationExists(constants_3.UBER), optionalButtonProps: {
                    label: "Apply Markup",
                    onClick: function () {
                        onOptionButton(constants_3.UBER);
                    },
                }, onClick: function () {
                    onAddIntegration(constants_3.UBER);
                } }), (0, jsx_runtime_1.jsx)(channel_1.default, { title: "", logo: gmc_logo_svg_1.default, learnMoreLink: "https://merchants.google.com", label: "By connecting your  Google Merchant Center, you agree that your data will be visible and manageable on the Letstrade platform.", optionalButton: _integrationExists(constants_2.GOOGLE_MERCHANT_CENTER), optionalButtonProps: {
                    label: "Upload Inventory file",
                    onClick: function () {
                        onOptionButton(constants_2.GOOGLE_MERCHANT_CENTER);
                    },
                }, onClick: function () {
                    onAddIntegration(constants_2.GOOGLE_MERCHANT_CENTER);
                } }), (0, jsx_runtime_1.jsx)(channel_1.default, { title: "Algolia", 
                //  logo={""}
                learnMoreLink: "https://www.algolia.com/", label: "By connecting your account, you agree to \n      Algolia's terms and conditions.\n      You need to follow Algolia's customer support and delivery & return policies when selling on Algolia.\n      ", onClick: function () {
                    onAddIntegration(constants_1.ALGOLIA);
                } })] })));
};
exports.default = AllChannelComponent;
